import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbDemoRegistrationComponent } from './kb-demo-registration.component';
import { ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { KbDemoRegistrationFormComponent } from './kb-demo-registration-form/kb-demo-registration-form.component';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, MediaModule, PageSlotModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WaierpopupComponent } from './waierpopup/waierpopup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { VehicalPopupComponent } from './vehical-popup/vehical-popup.component';



@NgModule({
  declarations: [KbDemoRegistrationComponent, KbDemoRegistrationFormComponent,
    WaierpopupComponent, VehicalPopupComponent],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    UrlModule,
    FormsModule,
    MediaModule,
    ReactiveFormsModule,
    PageSlotModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    RecaptchaModule,
    RecaptchaFormsModule,

    ConfigModule.withConfig({
      cmsComponents: {
        MyDemoRegistrationFlexComponent: {
          component: KbDemoRegistrationComponent,
        },
        MyDemoRegistrationFormFlexComponent: {
          component: KbDemoRegistrationFormComponent,
        },
      },
    }),
    RouterModule.forChild([
      {
        path: 'myDemoRegistration/form',
        data: { pageLabel: 'myDemoRegistration/form' },
        component: KbDemoRegistrationFormComponent,
        canActivate: [CmsPageGuard],
      },
    ]),
  ]
})
export class KbDemoRegistrationModule { }
